export { default, Component } from './ServiceCard';
